import styled from 'styled-components'

import Chip from '@material-ui/core/Chip'
import Typography from '@material-ui/core/Typography'

import colors from '@galo-monitor/styles/colors'
import fonts from '@galo-monitor/styles/fonts'

export const CardTitle = styled(Typography)`
  font-weight: ${ fonts.fontWeight.bold };
`

export const SegmentChip = styled(Chip)`
  height: 1.5rem;
  background-color: ${ colors.green2 };
  color: ${ colors.white };
  font-weight: ${ fonts.fontWeight.semiBold };
`

export const TextBold = styled(Typography)`
  font-weight: ${ fonts.fontWeight.semiBold };
`
